module.exports = __webpack_public_path__ + "static/img/new-Login_bg.dee1277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-Login_bg.jpg
// module id = YIev
// module chunks = 18